import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const onboardingApi = createApi({
    reducerPath: 'onboardingApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.NEXT_PUBLIC_API_URL}/onboarding`, // Adjusted to avoid double deckwale segment
        prepareHeaders: (headers, { getState }) => {
            const token = (getState() as any).auth.token || (typeof window !== 'undefined' ? localStorage.getItem('token') : null);
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ['Onboarding'],
    endpoints: (builder) => ({
        getOnboardingStatus: builder.query({
            query: () => '/status',
            providesTags: ['Onboarding'],
        }),
        getOnboardingData: builder.query({
            query: () => '/data',
            providesTags: ['Onboarding'],
        }),
        saveStep1: builder.mutation({
            query: (data: { role: string }) => ({
                url: '/step/1',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Onboarding'],
        }),
        saveStep2: builder.mutation({
            query: (data: { companyWebsite: string | null }) => ({ // Allow null if skipped? Docs say optional. If empty string sent as null or empty string? Usually empty string is fine if optional.
                url: '/step/2',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Onboarding'],
        }),
        saveStep3: builder.mutation({
            query: (data: { linkedin?: string; twitter?: string }) => ({
                url: '/step/3',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Onboarding'],
        }),
        saveStep4: builder.mutation({
            query: (data: { documentTypes: string[]; customDocumentType?: string }) => ({
                url: '/step/4',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Onboarding'],
        }),
        saveStep5: builder.mutation({
            query: (data: { referralSource: string; referralSourceOther?: string }) => ({
                url: '/step/5',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Onboarding'],
        }),
        skipOnboarding: builder.mutation({
            query: () => ({
                url: '/skip',
                method: 'POST',
            }),
            invalidatesTags: ['Onboarding'],
        }),
    }),
});

export const {
    useGetOnboardingStatusQuery,
    useGetOnboardingDataQuery,
    useSaveStep1Mutation,
    useSaveStep2Mutation,
    useSaveStep3Mutation,
    useSaveStep4Mutation,
    useSaveStep5Mutation,
    useSkipOnboardingMutation,
} = onboardingApi;
